// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1XpTOds5x3KYMsebkFUjZ7"};